import { render, staticRenderFns } from "./bfheadmaster.vue?vue&type=template&id=3aebdcb0&scoped=true&"
import script from "./bfheadmaster.vue?vue&type=script&lang=js&"
export * from "./bfheadmaster.vue?vue&type=script&lang=js&"
import style0 from "./bfheadmaster.vue?vue&type=style&index=0&id=3aebdcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebdcb0",
  null
  
)

export default component.exports